import WorkInProgress from './WorkInProgress';

export default WorkInProgress;
